import { TextColors, PremiumColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { isLeftToRight, isRightToLeft } from '@picsart/design-system/foundation/styleHelpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      paddingTop: Spacings.s64,
      paddingBottom: Spacings.s64,
      [mediaQuery(1365)]: {
        paddingTop: Spacings.s40,
        paddingBottom: Spacings.s40,
      },
      [mediaQuery(1023)]: {
        paddingTop: Spacings.s32,
        paddingBottom: Spacings.s32,
      },
    },
    content: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridTemplateRows: 'auto',
      gridGap: Spacings.s24,
      listStyleType: 'none',
      [mediaQuery(1023)]: {
        gridTemplateColumns: '1fr',
        maxWidth: 432,
        margin: 'auto',
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        maxWidth: 312,
      },
    },
    title: {
      display: '-webkit-box',
      lineClamp: 2,
      boxOrient: 'vertical',
      maxWidth: 856,
      margin: [Spacings.s0, 'auto', Spacings.s72],
      fontSize: FontSizes.s36,
      fontWeight: FontWeights.semibold,
      textAlign: 'center',
      lineHeight: LineHeights.l48,
      color: TextColors.tint1,
      overflow: 'hidden',

      [mediaQuery(1023)]: {
        lineClamp: 4,
        marginTop: Spacings.s32,
        maxWidth: 456,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '-webkit-line-clamp': 5,
        marginTop: Spacings.s24,
        fontSize: FontSizes.s30,
        lineHeight: LineHeights.l32,
      },
    },
    benefitItem: {
      position: 'relative',
      maxWidth: 400,

      [mediaQuery(1365)]: {
        maxWidth: 296,
      },

      [mediaQuery(1023)]: {
        maxWidth: 432,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        maxWidth: 312,
      },

      [isLeftToRight]: {
        paddingLeft: Spacings.s48,
      },
      [isRightToLeft]: {
        paddingRight: Spacings.s48,
      },
    },
    icon: {
      display: 'inline-block',
      width: 32,
      height: 32,
      position: 'absolute',
      top: Spacings.s0,
      fill: PremiumColors.base.default,

      [isLeftToRight]: {
        left: Spacings.s0,
      },
      [isRightToLeft]: {
        right: Spacings.s0,
      },

      '& > svg': {
        '& > path': {
          fill: PremiumColors.base.default,
        },
      },
    },
    subTitle: {
      display: 'block',
      fontWeight: FontWeights.bold,
      fontSize: FontSizes.s20,
      color: TextColors.tint1,
      lineHeight: LineHeights.l28,
    },
    contentHolder: {
      marginTop: Spacings.s12,
      fontWeight: FontWeights.medium,
      fontSize: FontSizes.s16,
      color: TextColors.tint1,
      lineHeight: LineHeights.l24,
    },

    // skeleton
    skeletonWrapper: {
      width: '100%',
      margin: [Spacings.s0, 'auto'],
      maxWidth: 1320,
      '&.$narrow': {
        boxSizing: 'border-box',
        padding: [Spacings.s0, 120],

        [mediaQuery(1365)]: {
          position: 'initial',
          maxWidth: 934,
        },

        [mediaQuery(1023)]: {
          padding: [Spacings.s0, Spacings.s32],
        },

        // [mediaQuery(766)]: {
        '@media screen and (max-width: 766px)': {
          padding: [Spacings.s0, Spacings.s24],
        },
      },
    },

    titleSkeleton: {
      margin: [Spacings.s0, 'auto', Spacings.s72],
      width: '100%',
      maxWidth: 300,
      height: 40,
    },
    subTitleSkeleton: {
      marginBottom: Spacings.s8,
      height: 32,
    },
    descriptionSkeleton: {
      height: 32,
    },
  }),
  {
    name: 'blocks-witht-ticks',
  },
);

export default useStyles;
